<div class="flex h-screen" [ngClass]="{'87SnUZ7TrBpM' : isManager}" >
    <div class="w-full xl:w-4 h-full text-center px-6 py-6 flex flex-column justify-content-between">
  <div *ngIf="subSiteName">
            <img [src]="'assets/layout/images/logo-{{subSiteName}}.svg'" class="login-logo" alt="diamond-layout" />
          </div>
          <div *ngIf="!subSiteName">
            <img [src]="'assets/layout/images/logo-dark.svg'" class="login-logo" alt="diamond-layout" />
          </div>
        <div class="flex flex-column align-items-center gap-4">
            <div class="mb-3">
                <h2 id="login">{{'login.connexion' | translate}}</h2>
                <p> <a class="text-primary hover:underline cursor-pointer font-medium" [routerLink]="['/auth/forgotpassword']" >{{'login.mot_de_passe_oublie' | translate}}</a></p>
            </div>
            <input (keydown.enter)="authenticate()" pInputText id="email" placeholder="{{'login.email' | translate}}" [(ngModel)]="credentials.username" (ngModelChange)="resetLoginErrors()" class="w-20rem"
            [ngClass]="{'error-contour':credentials.username == (null || ''||undefined) && submitted } "/>
            <small *ngIf="(credentials.username == null || credentials.username === '' || credentials.username === undefined) && submitted" id="user-not-found-error" class="w-20rem p-error">{{'login.erreurs.champ-obligatoire' | translate}}</small>

            <p-password (keydown.enter)="authenticate()" id="password" placeholder="{{'login.pwd' | translate}}" [feedback]="false" [(ngModel)]="credentials.password" (ngModelChange)="resetLoginErrors()" [toggleMask]="true" inputStyleClass="w-20rem"
            [ngClass]="{'error-contour':credentials.password == (null || ''||undefined) && submitted} "></p-password>
            <small *ngIf="(credentials.password == null || credentials.password === '' || credentials.password === undefined) && submitted" id="password-error" class="w-20rem p-error">{{'login.erreurs.champ-obligatoire' | translate}}</small>
            <small *ngIf="isUserLocked()" id="user-locked-error" class="w-20rem p-error" [innerHTML]="'login.erreurs.compte-verouillé' | translate"></small>          <small *ngIf="isUserInactive()" id="user-inactive-error" class="w-20rem p-error">{{'login.erreurs.compte-inactif' | translate}}</small>
          <small *ngIf="isUserNotFound()" id="user-not-found-error" class="w-20rem p-error">{{'login.erreurs.identifiant-pass-incorrect' | translate}}</small>
          <small *ngIf="isUserDesactivated()" id="user-desactivated-error" class="w-20rem p-error">{{'login.erreurs.desactivated' | translate}}</small>
          <small *ngIf="isUserBlockedNoActiveContract()" id="user-desactivated-error" class="w-20rem p-error">{{'login.erreurs.no-contract-found' | translate}}</small>
          <button id="connexion" pButton label="Je me connecte" type="button" [loading]="loading" iconPos="right" (click)="authenticate()" class="w-20rem"></button>
            <button *ngIf="!hidePremConxProcess" id="first-connexion" pButton label="Première connexion" type="button"  iconPos="right" (click)="premiereConnexion()" class="w-20rem p-button-outlined"></button>
        </div>


      <p id="informative-text" class="text-color-secondary font-semibold">{{'login.info9' | translate}} <span id="lien" class=" underline cursor-pointer" (click)="showInfo()" >{{'login.info10' | translate}}</span></p>
          <div>
        <span class="footer-copyright">Tessi - {{currentYear}}<br>{{appVersion}}
        </span>
      </div>
    </div>

  <app-page-login-img class="w-8 hidden lg:flex flex-column justify-content-between" [pageLogin]="pageLogin" [imageSrc]="imageSrc" [isVisible] = "isVisible" [colorCode]="colorCode"></app-page-login-img>

</div>

<app-page-login-popups (popupsInfo)="getPopupInfo($event)" (popupsFirstConnection)="getPopupFirstConnection($event)"
    [popupType]="popupType"></app-page-login-popups>

<!--  START  Info dialog pour Cliquez ici -->

<app-info-dialog [popupsInfo]="popupsInfo" [display_dialog_info]="display_dialog_info"
    (closed)="dialogInfoClose($event)"></app-info-dialog>
<!--  END  Info dialog pour Cliquez ici -->

<!--  START  Premiere connexion dialog -->
<p-dialog header="Title" [(visible)]="display_premiere_connexion" [modal]="true"
    [breakpoints]="{'1100px': '75vw', '640px': '100vw'}" [style]="{width: '35vw'}">
    <ng-template pTemplate="header">
    <h3 id="title-popup">{{popupsFirstConnection?.title}}</h3>
    </ng-template>
  <p id="popup-content" [innerHTML]="safeHtml"></p>
    <ng-template pTemplate="footer">
        <div class="button-container">
            <button pButton pRipple (click)="navigateToPremiereConnexion(false)" type="button" label="Non" id="close"
                icon="pi pi-times" class="p-button-text" iconPos="left"></button>
            <button pButton pRipple (click)="navigateToPremiereConnexion(true)" type="button" label="Oui" id="redirection"
                icon="pi pi-check" class="p-button-text" iconPos="left"></button>
        </div>
    </ng-template>
</p-dialog>
<!--  END  Premiere connexion dialog -->


<p-toast position="top-right" key="ERROR_TOKEN"></p-toast>
<p-toast position="top-right" key="SUCCESS_ACTIVATION_ACCOUNT"></p-toast>
<p-toast position="top-right" key="adhesion"></p-toast>
